<template>
  <div class="sidebar-main-page col-block" :class="[{ active: active }, type]">
    <div class="sidebar-main-container width-transition col-block width-full" :style="{ flex: 1 }">
      <a v-if="['default'].includes(type)" class="sidebar-main-logo-container center-block" :href="externalLinkDatas()['compassbioinfo']" target="_blank">
        <div class="sidebar-main-logo-block row-block">
          <div class="sidebar-main-logo-icon center-block">
            <img :src="require('../../assets/icons/compassbioinfo-icon.svg')" alt="" :style="{ 'max-width': '20px' }">
          </div>
          <div class="sidebar-main-logo-title hidden-text width-transition">
            <div v-html="$t('LAYOUT.sidebar.___logoTitle').split(' ').join('<br>')"></div>
          </div>
        </div>
      </a>
      <div class="sidebar-main-menu-list-container col-block width-full">
        <router-link
          class="sidebar-main-menu-field col-block width-full"
          v-for="(menuOption, moindex) in menuOptions['top']"
          :key="moindex"
          :class="{ active: menuOption.active }"
          :to="menuOption.to"
        >
          <div class="sidebar-main-menu-container center-block" :style="{ flex: 1 }">
            <div class="sidebar-main-menu-block row-block">
              <div class="sidebar-main-menu-icon center-block icon-block" :style="{ '--size': '20px' }">
                <img :src="menuOption.icon" alt="">
              </div>
              <div class="sidebar-main-menu-title hidden-text width-transition">{{ menuOption.title }}</div>
            </div>
          </div>
        </router-link>
      </div>
      <div :style="{ flex: 1 }"></div>
      <div class="sidebar-main-menu-list-container col-block width-full">
        <router-link
          class="sidebar-main-menu-field col-block width-full"
          v-for="(menuOption, moindex) in menuOptions['bottom']"
          :key="moindex"
          :class="{ active: menuOption.active }"
          :to="menuOption.to"
        >
          <div class="sidebar-main-menu-container center-block" :style="{ flex: 1 }">
            <div class="sidebar-main-menu-block row-block">
              <div class="sidebar-main-menu-icon center-block icon-block" :style="{ '--size': '20px' }">
                <img :src="menuOption.icon" alt="">
              </div>
              <div class="sidebar-main-menu-title hidden-text width-transition">{{ menuOption.title }}</div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="sidebar-main-button-container center-block">
        <a :href="externalLinkDatas()['inherinext']" target="_blank">
          <button class="sidebar-main-button main-button small-button circle-button row-block width-transition" :class="{ 'flex-reverse': ['ja'].includes($i18n.locale) }">
            <div class="sidebar-main-button-text">{{ $t('LAYOUT.sidebar.___tryButton01') }}</div>
            <div class="sidebar-main-button-text hidden-text width-transition">{{ $t('LAYOUT.sidebar.___tryButton02') }}</div>
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { externalLinkDatas } from '../../constants/global/data'

export default {
  props: {
    type: {
      type: String,
      default: () => 'default'
    },
    active: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    // static
    menuOptions () {
      return {
        'top': [
          {
            icon: require('../../assets/menuIcons/phenotype-menu-icon.svg'),
            title: this.$t('LAYOUT.sidebar.menuOption.title.___phenotype'),
            to: { name: 'phenotypeDisease' },
            active: ['phenotypeDisease'].includes(this.$route.name)
          },
          {
            icon: require('../../assets/menuIcons/gene-panel-menu-icon.svg'),
            title: this.$t('LAYOUT.sidebar.menuOption.title.___genePanel'),
            to: { name: 'genePanel' },
            active: ['genePanel'].includes(this.$route.name)
          }
        ],
        'bottom': [
          // {
          //   icon: require('../../assets/menuIcons/introduction-menu-icon.svg'),
          //   title: this.$t('LAYOUT.sidebar.menuOption.title.___introduction'),
          //   to: { name: 'main' },
          //   active: ['main'].includes(this.$route.name)
          // }
        ]
      }
    },
    // global
    externalLinkDatas () { return externalLinkDatas }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/main.vue